query EnvironmentalMetrics($filter: EnvironmentalMetricFilter) {
  environmentalMetrics(filter: $filter) {
    nodes {
      id
      environmentalMetric
      layoutType
      environmentalMetricItems(
        orderBy: ENVIRONMENTAL_IMPACT_TYPE_BY_ENVIRONMENTAL_IMPACT_TYPE_ID__SORT_ORDER_ASC
      ) {
        nodes {
          environmentalImpact {
            id
            environmentalImpact
            isIntegerFormat
            isFloatFormat
            isAmountFormat
          }
        }
      }
    }
  }
}
